import {
  FormControl,
  FormLabel,
  TextField,
  FormHelperText,
} from "@mui/material";
import { InputWrapper, LabelStyle } from "../../Common/styles/form";
import TipTapFormik from "../../Tiptap/TipTapFormik";
import { SurveyEmailContentVariableChips } from "../surveyEmailContentVariables";

const RemindersTranslation = ({
  touched,
  errors,
  getFieldProps,
  setFieldValue,
  preview,
}: any) => {
  return (
    <>
      {!preview && <SurveyEmailContentVariableChips />}
      <FormControl sx={{ ...InputWrapper, mb: 1 }}>
        <FormLabel sx={LabelStyle} htmlFor="email-subject">
          Email Subject <span style={{ color: "red" }}>*</span>
        </FormLabel>
        <TextField
          placeholder="Subject"
          id="email-subject"
          {...getFieldProps("emailSubject")}
          error={touched?.emailSubject && errors?.emailSubject ? true : false}
          helperText={
            touched?.emailSubject && errors?.emailSubject
              ? (errors?.emailSubject as string)
              : " "
          }
          inputProps={{ readOnly: preview }}
        />
      </FormControl>
      <FormControl sx={InputWrapper}>
        <FormLabel sx={LabelStyle} htmlFor="message-body">
          Message Body <span style={{ color: "red" }}>*</span>
        </FormLabel>
        <TipTapFormik
          name="emailBody"
          setFieldValue={setFieldValue}
          preview={preview}
        />
        {touched?.emailBody && errors?.emailBody && (
          <FormHelperText error>{errors?.emailBody as string}</FormHelperText>
        )}
      </FormControl>
    </>
  );
};

export default RemindersTranslation;
